import { render, staticRenderFns } from "./MainColumn.vue?vue&type=template&id=16e493be&scoped=true&"
import script from "./MainColumn.vue?vue&type=script&lang=js&"
export * from "./MainColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e493be",
  null
  
)

export default component.exports